import { render, staticRenderFns } from "./SingleCommission.vue?vue&type=template&id=28101394"
import script from "./SingleCommission.vue?vue&type=script&lang=js"
export * from "./SingleCommission.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports